const getApiUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }

  if (process.env.NODE_ENV === 'test') {
    return 'https://api.polimorphic.com'
  }

  if (typeof window === 'undefined') {
    return 'https://api.polimorphic.com'
  }

  const hostname = window.location.hostname

  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return `http://localhost:${process.env.REACT_APP_BACKEND_PORT || 8000}`
  } else if (hostname.includes('staging.usepoli.com')) {
    return 'https://api-staging.usepoli.com'
  } else if (hostname.includes('demo.usepoli.com')) {
    return 'https://api-demo.usepoli.com'
  } else if (hostname.includes('pentest.usepoli.com')) {
    return 'https://api-pentest.usepoli.com'
  }

  return 'https://api.polimorphic.com'
}

export const API_URL = getApiUrl()
export const IS_LOCAL = API_URL.includes('localhost')
export const IS_DEMO = API_URL.includes('demo')
export const IS_STAGING = API_URL.includes('staging') || IS_DEMO
export const IS_PENTEST = API_URL.includes('pentest')
export const IS_PROD = API_URL.includes('https://api.polimorphic.com')

export const QUILL_PUBLIC_KEY = IS_PROD ? '66cf63a4f0d207000b2f594f' : '66ceb7f2d816f6000b6bf10e'
export const COMMIT_HASH = process.env.REACT_APP_COMMIT_HASH
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_API_KEY
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
export const STRIPE_TEST_PUBLIC_KEY = process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY
export const STRIPE_LIVE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_LIVE_PUBLIC_KEY
export const STATSIG_TEST_CLIENT_KEY = process.env.REACT_APP_STATSIG_TEST_CLIENT_KEY
export const STATSIG_LIVE_CLIENT_KEY = process.env.REACT_APP_STATSIG_LIVE_CLIENT_KEY

export const STRIPE_PUBLIC_KEY = IS_PROD ? STRIPE_LIVE_PUBLIC_KEY : STRIPE_TEST_PUBLIC_KEY
export const STATSIG_CLIENT_KEY = IS_PROD ? STATSIG_LIVE_CLIENT_KEY : STATSIG_TEST_CLIENT_KEY

// Killswitch to control GET vs POST for initialize-ai endpoint, defaults to True
export const USE_INITIALIZE_AI_GET =
  process.env.REACT_APP_USE_INITIALIZE_AI_GET?.toLowerCase() !== 'false'

export const BASE_URL = IS_LOCAL
  ? `http://localhost:${process.env.REACT_APP_FRONTEND_PORT || 3000}`
  : IS_DEMO
    ? 'https://demo.usepoli.com'
    : IS_PENTEST
      ? 'https://pentest.usepoli.com'
      : IS_STAGING
        ? 'https://staging.usepoli.com'
        : 'https://app.polimorphic.com'

export const SECURE_CLOUDFRONT_DOMAIN = IS_PROD
  ? 'https://secure.polimorphic.com'
  : 'https://secure.usepoli.com'

// Kept for backwards compatibility
export const BASE_URL_WITH_ALL_REACT = BASE_URL
export const BASE_URL_WITH_REACT = BASE_URL
